export const volunteerParticipation = [
  {
    Year: "2018-2019",
    Volunteers: 13852,
    YearColor: "#009BBB",
  },
  {
    Year: "2017-2018",
    Volunteers: 13749,
    YearColor: "#FF8849",
  },
  {
    Year: "2016-2017",
    Volunteers: 12081,
    YearColor: "#74C037",
  },
]
